import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import * as actions from './rfr-delivery-data.actions';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import * as ctrlsConstants from 'src/app/shared/_config/ctrls/ctrls-constants';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { RfrDeliveryDataResponseI } from 'src/app/api/rfr-delivery-data/rfr-delivery-data.result.int';

@Injectable()
export class RfrDeliveryDataEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiRfrMethod.rfrDeliveryData, {
                [ctrlsConstants.ctrlDeliveryId]: params.query.deliveryId,
            }).pipe(
                map((data: RfrDeliveryDataResponseI) => actions.received({
                    data
                })),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );
}
